<div class="flex-child-lang">
  @if (!isDictating()) {
    <app-dropdown-menu
      [title]="showLabel ? getCurrentLanguageName().label : null"
      [icon]="getCurrentLanguageName().icon"
      [iconType]="getCurrentLanguageName().iconType"
      [options]="languages"
      [buttonStyle]="'flat'"
      [disabled]="isDictating()"
      (optionSelected)="setLanguage($event)"
    ></app-dropdown-menu>
  }
</div>
